import { render } from "./CartPricesView.vue?vue&type=template&id=e2365028"
import script from "./CartPricesView.vue?vue&type=script&lang=js"
export * from "./CartPricesView.vue?vue&type=script&lang=js"

import "./CartPricesView.vue?vue&type=style&index=0&id=e2365028&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__